// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row[data-v-204784c6]{color:#fff}.row .link[data-v-204784c6]{color:#fff;font:inherit;font-size:2rem}.row .btn.white[data-v-204784c6]{background-color:#fff;color:#ec6625}.row .btn.white [class^=icon-][data-v-204784c6]:before{color:#ec6625}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
